import { env } from "../src/environments";
import { getVersion } from "./jsxProviders/helpers/tmpDir";
import { environment } from "./store/utils/consts";
function isNewer(latestVersion: string, currentVersion: string) {
  if (!latestVersion || !currentVersion) return false;
  const latestArray = latestVersion.split(/-|\./);
  const currentArray = currentVersion.split(/-|\./);
  const maxLength = Math.max(latestArray.length, currentArray.length);
  // this is a for loop because You can't stop forEach execution other than throwing an exception.
  for (let i = 0; i < maxLength; ++i) {
    const latestPart = latestArray[i];
    const currentPart = currentArray[i];
    // @ts-ignore/
    if (!isNaN(currentPart) && !isNaN(latestPart)) {
      if (latestPart > currentPart) {
        return true;
      }
      if (latestPart < currentPart) {
        return false;
      }
    } else if (latestPart !== currentPart) {
      return false;
    }
  }
  return false;
}

export async function alertForNewVersion(
  setNewerVersionModalVisible: (type: "ui" | "main") => void,
  setNewerVersion: (url: string, version: string, uiVersion: string) => void
) {
  const lastVersion = await (
    await fetch(env[environment].latestVersion)
  ).json();
  const currentMainVersion = await getVersion();
  setNewerVersion(
    env[environment].latestVersionDownload,
    lastVersion.version,
    lastVersion.uiVersion
  );
  if (currentMainVersion && isNewer(lastVersion.version, currentMainVersion)) {
    setNewerVersionModalVisible("main");
  } else if (
    currentMainVersion && //if version is defined meaning not a test version
    process.env.REACT_APP_VERSION &&
    isNewer(lastVersion.uiVersion, process.env.REACT_APP_VERSION)
  ) {
    setNewerVersionModalVisible("ui");
  }
}
